import {
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result3t1vadv16kmzk as Result,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  newThrowablezl37abp36p5f as newThrowable,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString_0,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString1h6jjoch8cjt8 as toString_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { stackTraceToString2670q6lbhdojj as stackTraceToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { get_DEVELOPMENT_MODE18ax9b1n971lk as get_DEVELOPMENT_MODE } from './ByteChannel.web.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { DisposableHandle1uzxt8frdchxn as DisposableHandle } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from '../../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import {
  Companion_instance20st388c71va as Companion_instance_0,
  access$_get_origin__hdh1qz8t4atr48tdww as access$_get_origin__hdh1qz,
  get_CLOSED3uiwvc5y98ftj as get_CLOSED,
  CloseToken4utf44psnuyc as CloseToken,
} from './CloseToken.mjs';
import {
  ClosedReadChannelException9jdpzh6uy12w as ClosedReadChannelException,
  ClosedWriteChannelException1eeenxj0c4bxu as ClosedWriteChannelException,
  ClosedByteChannelException3il8gfpye60w as ClosedByteChannelException,
} from './Exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Debug.common.mjs';
import { rethrowCloseCauseIfNeededeln8lm5agg4u as rethrowCloseCauseIfNeeded } from './ByteReadChannelOperations.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  numberToLong2pakxeg38estk as numberToLong,
  add2suhfggl4zvkk as add,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  awaitContent$default2x8iq90jfihc1 as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ByteWriteChannel3jkhlhzuuoxp1 as ByteWriteChannel } from './ByteWriteChannel.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        this.n4i_1 = new (Closed())(null);
        var tmp = this;
        // Inline function 'kotlin.Companion.success' call
        tmp.o4i_1 = _Result___init__impl__xyqfz8(Unit_instance);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_1;
function Companion_getInstance() {
  if (Companion_instance_1 === VOID)
    new (Companion())();
  return Companion_instance_1;
}
var EmptyClass;
function Empty() {
  if (EmptyClass === VOID) {
    class $ {
      toString() {
        return 'Empty';
      }
      hashCode() {
        return -231472095;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Empty()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Empty');
    EmptyClass = $;
  }
  return EmptyClass;
}
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
var ClosedClass;
function Closed() {
  if (ClosedClass === VOID) {
    class $ {
      constructor(cause) {
        this.p4i_1 = cause;
      }
      toString() {
        return 'Closed(cause=' + toString(this.p4i_1) + ')';
      }
      hashCode() {
        return this.p4i_1 == null ? 0 : hashCode(this.p4i_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Closed()))
          return false;
        if (!equals(this.p4i_1, other.p4i_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Closed');
    ClosedClass = $;
  }
  return ClosedClass;
}
function resume() {
  return this.r4i().rc(Companion_getInstance().o4i_1);
}
function resume_0(throwable) {
  var tmp = this.r4i();
  var tmp_0;
  if (throwable == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(throwable));
    tmp_0 = new (Result())(tmp$ret$0);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp.rc(tmp1_elvis_lhs == null ? Companion_getInstance().o4i_1 : tmp1_elvis_lhs.it_1);
}
var TaskClass;
function Task() {
  if (TaskClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Task');
    TaskClass = $;
  }
  return TaskClass;
}
var ReadClass;
function Read() {
  if (ReadClass === VOID) {
    class $ {
      constructor(continuation) {
        this.v4i_1 = continuation;
        this.w4i_1 = null;
        if (get_DEVELOPMENT_MODE()) {
          var tmp = this;
          // Inline function 'kotlin.also' call
          var this_0 = newThrowable('ReadTask 0x' + toString_1(hashCode(this.v4i_1), 16));
          stackTraceToString(this_0);
          tmp.w4i_1 = this_0;
        }
      }
      r4i() {
        return this.v4i_1;
      }
      q4i() {
        return this.w4i_1;
      }
      s4i() {
        return 'read';
      }
    }
    protoOf($).t4i = resume;
    protoOf($).u4i = resume_0;
    initMetadataForClass($, 'Read', VOID, VOID, [Task()]);
    ReadClass = $;
  }
  return ReadClass;
}
var WriteClass;
function Write() {
  if (WriteClass === VOID) {
    class $ {
      constructor(continuation) {
        this.x4i_1 = continuation;
        this.y4i_1 = null;
        if (get_DEVELOPMENT_MODE()) {
          var tmp = this;
          // Inline function 'kotlin.also' call
          var this_0 = newThrowable('WriteTask 0x' + toString_1(hashCode(this.x4i_1), 16));
          stackTraceToString(this_0);
          tmp.y4i_1 = this_0;
        }
      }
      r4i() {
        return this.x4i_1;
      }
      q4i() {
        return this.y4i_1;
      }
      s4i() {
        return 'write';
      }
    }
    protoOf($).t4i = resume;
    protoOf($).u4i = resume_0;
    initMetadataForClass($, 'Write', VOID, VOID, [Task()]);
    WriteClass = $;
  }
  return WriteClass;
}
function moveFlushToReadBuffer($this) {
  // Inline function 'io.ktor.utils.io.locks.synchronized' call
  $this.c4j_1;
  $this.a4j_1.m4g($this.e4j_1);
  $this.b4j_1 = 0;
  // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
  var current = $this.d4j_1.kotlinx$atomicfu$value;
  var tmp;
  if (current instanceof Write()) {
    tmp = $this.d4j_1.atomicfu$compareAndSet(current, Empty_instance);
  } else {
    tmp = false;
  }
  if (tmp) {
    current.t4i();
  }
}
function closeSlot($this, cause) {
  var closeContinuation = !(cause == null) ? new (Closed())(cause) : Companion_getInstance().n4i_1;
  var continuation = $this.d4j_1.atomicfu$getAndSet(closeContinuation);
  if (isInterface(continuation, Task())) {
    continuation.u4i(cause);
  }
  var tmp0_safe_receiver = $this.h4j_1.atomicfu$getAndSet(null);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver(cause);
}
var sam$kotlinx_coroutines_DisposableHandle$0Class;
function sam$kotlinx_coroutines_DisposableHandle$0() {
  if (sam$kotlinx_coroutines_DisposableHandle$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.i4j_1 = function_0;
      }
      sz() {
        return this.i4j_1();
      }
      i5() {
        return this.i4j_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, DisposableHandle()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle(), FunctionAdapter()]);
    sam$kotlinx_coroutines_DisposableHandle$0Class = $;
  }
  return sam$kotlinx_coroutines_DisposableHandle$0Class;
}
function ByteChannel$invokeOnClose$lambda() {
  return Unit_instance;
}
function ByteChannel$invokeOnClose$lambda_0() {
  return Unit_instance;
}
var ByteChannelClass;
function ByteChannel() {
  if (ByteChannelClass === VOID) {
    class $ {
      constructor(autoFlush) {
        autoFlush = autoFlush === VOID ? false : autoFlush;
        this.z4i_1 = autoFlush;
        this.a4j_1 = new (Buffer())();
        this.b4j_1 = 0;
        this.c4j_1 = new Object();
        this.d4j_1 = atomic$ref$1(Empty_instance);
        this.e4j_1 = new (Buffer())();
        this.f4j_1 = new (Buffer())();
        this.g4j_1 = atomic$ref$1(null);
        this.h4j_1 = atomic$ref$1(null);
      }
      j4j() {
        return this.z4i_1;
      }
      k4j() {
        return this.b4j_1 < 1048576;
      }
      l4j() {
        var tmp0_safe_receiver = this.g4j_1.kotlinx$atomicfu$value;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'io.ktor.utils.io.Companion.throwOrNull' call
          // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
          var tmp0_subject = access$_get_origin__hdh1qz(tmp0_safe_receiver);
          var tmp;
          if (tmp0_subject == null) {
            tmp = null;
          } else {
            if (isInterface(tmp0_subject, CopyableThrowable())) {
              tmp = access$_get_origin__hdh1qz(tmp0_safe_receiver).l13();
            } else {
              if (tmp0_subject instanceof CancellationException()) {
                tmp = CancellationException().p(access$_get_origin__hdh1qz(tmp0_safe_receiver).message, access$_get_origin__hdh1qz(tmp0_safe_receiver));
              } else {
                var p0 = access$_get_origin__hdh1qz(tmp0_safe_receiver);
                tmp = ClosedReadChannelException().q4j(p0);
              }
            }
          }
          var tmp0_safe_receiver_0 = tmp;
          var tmp_0;
          if (tmp0_safe_receiver_0 == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            throw tmp0_safe_receiver_0;
          }
        }
        if (this.e4j_1.v3v()) {
          moveFlushToReadBuffer(this);
        }
        return this.e4j_1;
      }
      r4j() {
        if (this.x4j()) {
          var tmp0_safe_receiver = this.g4j_1.kotlinx$atomicfu$value;
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'io.ktor.utils.io.Companion.throwOrNull' call
            // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
            var tmp0_subject = access$_get_origin__hdh1qz(tmp0_safe_receiver);
            var tmp_0;
            if (tmp0_subject == null) {
              tmp_0 = null;
            } else {
              if (isInterface(tmp0_subject, CopyableThrowable())) {
                tmp_0 = access$_get_origin__hdh1qz(tmp0_safe_receiver).l13();
              } else {
                if (tmp0_subject instanceof CancellationException()) {
                  tmp_0 = CancellationException().p(access$_get_origin__hdh1qz(tmp0_safe_receiver).message, access$_get_origin__hdh1qz(tmp0_safe_receiver));
                } else {
                  var p0 = access$_get_origin__hdh1qz(tmp0_safe_receiver);
                  tmp_0 = ClosedWriteChannelException().w4j(p0);
                }
              }
            }
            var tmp0_safe_receiver_0 = tmp_0;
            var tmp_1;
            if (tmp0_safe_receiver_0 == null) {
              tmp_1 = null;
            } else {
              // Inline function 'kotlin.let' call
              throw tmp0_safe_receiver_0;
            }
            tmp = tmp_1;
          }
          if (tmp == null)
            throw ClosedWriteChannelException().w4j();
        }
        return this.f4j_1;
      }
      y4j() {
        var tmp0_safe_receiver = this.g4j_1.kotlinx$atomicfu$value;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
          var tmp0_subject = access$_get_origin__hdh1qz(tmp0_safe_receiver);
          var tmp_0;
          if (tmp0_subject == null) {
            tmp_0 = null;
          } else {
            if (isInterface(tmp0_subject, CopyableThrowable())) {
              tmp_0 = access$_get_origin__hdh1qz(tmp0_safe_receiver).l13();
            } else {
              if (tmp0_subject instanceof CancellationException()) {
                tmp_0 = CancellationException().p(access$_get_origin__hdh1qz(tmp0_safe_receiver).message, access$_get_origin__hdh1qz(tmp0_safe_receiver));
              } else {
                var p0 = access$_get_origin__hdh1qz(tmp0_safe_receiver);
                tmp_0 = ClosedByteChannelException().c4k(p0);
              }
            }
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      x4j() {
        return !(this.g4j_1.kotlinx$atomicfu$value == null);
      }
      d4k() {
        return !(this.y4j() == null) || (this.x4j() && this.b4j_1 === 0 && this.e4j_1.v3v());
      }
      *e4k(min, $completion) {
        rethrowCloseCauseIfNeeded(this);
        if (this.e4j_1.q2() >= fromInt(min))
          return true;
        // Inline function 'io.ktor.utils.io.ByteChannel.sleepWhile' call
        var this_0 = this;
        $l$loop: while (add(numberToLong(this.b4j_1), this.e4j_1.q2()) < fromInt(min) && this.g4j_1.kotlinx$atomicfu$value == null) {
          // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
          // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
          (yield () => {
            var uCont = $completion;
            var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
            cancellable.z10();
            var tmp0 = this_0;
            var tmp2 = new (Read())(cancellable);
            $l$block_0: {
              // Inline function 'io.ktor.utils.io.ByteChannel.trySuspend' call
              var previous = tmp0.d4j_1.kotlinx$atomicfu$value;
              if (!(previous instanceof Closed())) {
                if (!tmp0.d4j_1.atomicfu$compareAndSet(previous, tmp2)) {
                  tmp2.t4i();
                  break $l$block_0;
                }
              }
              if (previous instanceof Read()) {
                previous.u4i(ConcurrentIOException().j4k(tmp2.s4i(), previous.q4i()));
              } else {
                if (isInterface(previous, Task())) {
                  previous.t4i();
                } else {
                  if (previous instanceof Closed()) {
                    tmp2.u4i(previous.p4i_1);
                    break $l$block_0;
                  } else {
                    if (!equals(previous, Empty_instance)) {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
              if (!(add(numberToLong(this.b4j_1), this.e4j_1.q2()) < fromInt(min) && this.g4j_1.kotlinx$atomicfu$value == null)) {
                // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
                var current = tmp0.d4j_1.kotlinx$atomicfu$value;
                var tmp;
                if (current instanceof Read()) {
                  tmp = tmp0.d4j_1.atomicfu$compareAndSet(current, Empty_instance);
                } else {
                  tmp = false;
                }
                if (tmp) {
                  current.t4i();
                }
              }
            }
            return cancellable.jy();
          });
        }
        if (this.e4j_1.q2() < 1048576n) {
          moveFlushToReadBuffer(this);
        }
        return this.e4j_1.q2() >= fromInt(min);
      }
      *l4k($completion) {
        rethrowCloseCauseIfNeeded(this);
        this.m4k();
        if (this.k4j())
          return Unit_instance;
        // Inline function 'io.ktor.utils.io.ByteChannel.sleepWhile' call
        var this_0 = this;
        $l$loop: while (!this.k4j() && this.g4j_1.kotlinx$atomicfu$value == null) {
          // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
          // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
          (yield () => {
            var uCont = $completion;
            var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
            cancellable.z10();
            var tmp0 = this_0;
            var tmp2 = new (Write())(cancellable);
            $l$block_0: {
              // Inline function 'io.ktor.utils.io.ByteChannel.trySuspend' call
              var previous = tmp0.d4j_1.kotlinx$atomicfu$value;
              if (!(previous instanceof Closed())) {
                if (!tmp0.d4j_1.atomicfu$compareAndSet(previous, tmp2)) {
                  tmp2.t4i();
                  break $l$block_0;
                }
              }
              if (previous instanceof Write()) {
                previous.u4i(ConcurrentIOException().j4k(tmp2.s4i(), previous.q4i()));
              } else {
                if (isInterface(previous, Task())) {
                  previous.t4i();
                } else {
                  if (previous instanceof Closed()) {
                    tmp2.u4i(previous.p4i_1);
                    break $l$block_0;
                  } else {
                    if (!equals(previous, Empty_instance)) {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
              if (!(!this.k4j() && this.g4j_1.kotlinx$atomicfu$value == null)) {
                // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
                var current = tmp0.d4j_1.kotlinx$atomicfu$value;
                var tmp;
                if (current instanceof Write()) {
                  tmp = tmp0.d4j_1.atomicfu$compareAndSet(current, Empty_instance);
                } else {
                  tmp = false;
                }
                if (tmp) {
                  current.t4i();
                }
              }
            }
            return cancellable.jy();
          });
        }
        return Unit_instance;
      }
      m4k() {
        if (this.f4j_1.v3v())
          return Unit_instance;
        // Inline function 'io.ktor.utils.io.locks.synchronized' call
        this.c4j_1;
        var count = convertToInt(this.f4j_1.q2());
        this.a4j_1.z4g(this.f4j_1);
        this.b4j_1 = this.b4j_1 + count | 0;
        // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
        var current = this.d4j_1.kotlinx$atomicfu$value;
        var tmp;
        if (current instanceof Read()) {
          tmp = this.d4j_1.atomicfu$compareAndSet(current, Empty_instance);
        } else {
          tmp = false;
        }
        if (tmp) {
          current.t4i();
        }
      }
      l6() {
        this.m4k();
        if (!this.g4j_1.atomicfu$compareAndSet(null, get_CLOSED()))
          return Unit_instance;
        closeSlot(this, null);
      }
      *n4k($completion) {
        // Inline function 'kotlin.runCatching' call
        var tmp;
        try {
          yield* this.l4k($completion);
          // Inline function 'kotlin.Companion.success' call
          tmp = _Result___init__impl__xyqfz8(Unit_instance);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var e = $p;
            // Inline function 'kotlin.Companion.failure' call
            tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        if (!this.g4j_1.atomicfu$compareAndSet(null, get_CLOSED()))
          return Unit_instance;
        closeSlot(this, null);
        return Unit_instance;
      }
      o4k(cause) {
        if (!(this.g4j_1.kotlinx$atomicfu$value == null))
          return Unit_instance;
        var closedToken = new (CloseToken())(cause);
        this.g4j_1.atomicfu$compareAndSet(null, closedToken);
        // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
        var tmp0_subject = access$_get_origin__hdh1qz(closedToken);
        var tmp;
        if (tmp0_subject == null) {
          tmp = null;
        } else {
          if (isInterface(tmp0_subject, CopyableThrowable())) {
            tmp = access$_get_origin__hdh1qz(closedToken).l13();
          } else {
            if (tmp0_subject instanceof CancellationException()) {
              tmp = CancellationException().p(access$_get_origin__hdh1qz(closedToken).message, access$_get_origin__hdh1qz(closedToken));
            } else {
              var p0 = access$_get_origin__hdh1qz(closedToken);
              tmp = ClosedByteChannelException().c4k(p0);
            }
          }
        }
        var wrappedCause = tmp;
        closeSlot(this, wrappedCause);
      }
      p4k(handler) {
        var existingCause = this.g4j_1.kotlinx$atomicfu$value;
        if (!(existingCause == null)) {
          // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
          var tmp0_subject = access$_get_origin__hdh1qz(existingCause);
          var tmp;
          if (tmp0_subject == null) {
            tmp = null;
          } else {
            if (isInterface(tmp0_subject, CopyableThrowable())) {
              tmp = access$_get_origin__hdh1qz(existingCause).l13();
            } else {
              if (tmp0_subject instanceof CancellationException()) {
                tmp = CancellationException().p(access$_get_origin__hdh1qz(existingCause).message, access$_get_origin__hdh1qz(existingCause));
              } else {
                var p0 = access$_get_origin__hdh1qz(existingCause);
                tmp = ClosedByteChannelException().c4k(p0);
              }
            }
          }
          handler(tmp);
          var tmp_0 = ByteChannel$invokeOnClose$lambda;
          return new (sam$kotlinx_coroutines_DisposableHandle$0())(tmp_0);
        }
        if (!this.h4j_1.atomicfu$compareAndSet(null, handler)) {
          // Inline function 'kotlin.error' call
          var message = 'Only one invokeOnClose handler is supported per channel';
          throw IllegalStateException().o(toString_0(message));
        }
        var cause = this.g4j_1.kotlinx$atomicfu$value;
        if (!(cause == null) && this.h4j_1.atomicfu$compareAndSet(handler, null)) {
          // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
          var tmp0_subject_0 = access$_get_origin__hdh1qz(cause);
          var tmp_1;
          if (tmp0_subject_0 == null) {
            tmp_1 = null;
          } else {
            if (isInterface(tmp0_subject_0, CopyableThrowable())) {
              tmp_1 = access$_get_origin__hdh1qz(cause).l13();
            } else {
              if (tmp0_subject_0 instanceof CancellationException()) {
                tmp_1 = CancellationException().p(access$_get_origin__hdh1qz(cause).message, access$_get_origin__hdh1qz(cause));
              } else {
                var p0_0 = access$_get_origin__hdh1qz(cause);
                tmp_1 = ClosedByteChannelException().c4k(p0_0);
              }
            }
          }
          handler(tmp_1);
          var tmp_2 = ByteChannel$invokeOnClose$lambda_0;
          return new (sam$kotlinx_coroutines_DisposableHandle$0())(tmp_2);
        }
        var tmp_3 = () => {
          this.h4j_1.atomicfu$compareAndSet(handler, null);
          return Unit_instance;
        };
        return new (sam$kotlinx_coroutines_DisposableHandle$0())(tmp_3);
      }
      toString() {
        return 'ByteChannel[' + hashCode(this) + ']';
      }
    }
    protoOf($).k4k = awaitContent$default;
    initMetadataForClass($, 'ByteChannel', ByteChannel, VOID, [ByteReadChannel(), ByteWriteChannel()], [1, 0]);
    ByteChannelClass = $;
  }
  return ByteChannelClass;
}
var ConcurrentIOExceptionClass;
function ConcurrentIOException() {
  if (ConcurrentIOExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(taskName, cause) {
        return new.target.j4k(taskName, cause);
      }
      static j4k(taskName, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.q('Concurrent ' + taskName + ' attempts', cause);
        captureStack($this, $this.i4k_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ConcurrentIOException');
    ConcurrentIOExceptionClass = $;
  }
  return ConcurrentIOExceptionClass;
}
//region block: init
Empty_instance = new (Empty())();
//endregion
//region block: exports
export {
  ByteChannel as ByteChannel3cxdguezl3lu7,
};
//endregion

//# sourceMappingURL=ByteChannel.mjs.map
